import request from '#/utils/request';
import { parseVer4DetailResponse } from '#/api/adapters/envelope';

/** GET `/aftersales/sign-receipt/{id}` */
export async function fetchSignReceiptDetail(id) {
  const { data: raw } = await request.get(`/aftersales/sign-receipt/${id}`);
  return parseVer4DetailResponse(raw);
}
